import api from '../api/client';
// import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
// import { io } from 'socket.io-client';
// import { useDispatch, useSelector } from 'react-redux';
// import config from './../config';

// const SocketContext = createContext(null);

// export const useSocket = () => {
//     const context = useContext(SocketContext);
//     if (!context) {
//         throw new Error('useSocket must be used within a SocketProvider');
//     }
//     return context;
// };

// export const SocketProvider = ({ children }) => {
//     // const { currentUser } = useAuth();
//     const currentUser = useSelector((state) => state.account.user);

//     const [socket, setSocket] = useState(null);
//     const [isConnected, setIsConnected] = useState(false);
//     const [connectionError, setConnectionError] = useState(null);
//     const environment = window.location.hostname === 'localhost' ? 'development' : 'production';
//     const apiUrl = config[environment].apiUrl;

//     // Initialize socket connection
//     const connectSocket = useCallback(() => {
//         if (!currentUser?.id) return;

//         try {
//             const token = localStorage.getItem('token');
//             console.log(token);
//             if (!token) throw new Error('Authentication token not found');

//             // Create new socket connection
//             const newSocket = io(apiUrl, {
//                 auth: {
//                     token: token
//                 },
//                 transports: ['websocket'],
//                 reconnection: true,
//                 reconnectionAttempts: 5,
//                 reconnectionDelay: 1000,
//                 reconnectionDelayMax: 5000
//             });

//             // Connection events
//             newSocket.on('connect', () => {
//                 setIsConnected(true);
//                 setConnectionError(null);
//                 console.log('Socket connected:', newSocket.id);
//             });

//             newSocket.on('disconnect', (reason) => {
//                 setIsConnected(false);
//                 console.log('Socket disconnected:', reason);

//                 if (reason === 'io server disconnect') {
//                     // Reconnect manually if server disconnects
//                     setTimeout(() => {
//                         newSocket.connect();
//                     }, 1000);
//                 }
//             });

//             newSocket.on('connect_error', (err) => {
//                 setIsConnected(false);
//                 setConnectionError(err.message);
//                 console.error('Socket connection error:', err.message);
//             });

//             newSocket.on('reconnect_attempt', (attempt) => {
//                 console.log(`Reconnection attempt #${attempt}`);
//             });

//             newSocket.on('reconnect_error', (err) => {
//                 setConnectionError(`Reconnect failed: ${err.message}`);
//             });

//             newSocket.on('reconnect_failed', () => {
//                 setConnectionError('Reconnect failed. Please refresh the page.');
//             });

//             setSocket(newSocket);

//             return newSocket;
//         } catch (err) {
//             console.error('Socket initialization error:', err);
//             setConnectionError(err.message);
//             return null;
//         }
//     }, [currentUser?.id, apiUrl]);

//     // Cleanup socket connection
//     const disconnectSocket = useCallback(() => {
//         if (socket) {
//             socket.off('connect');
//             socket.off('disconnect');
//             socket.off('connect_error');
//             socket.off('reconnect_attempt');
//             socket.off('reconnect_error');
//             socket.off('reconnect_failed');

//             socket.disconnect();
//             setSocket(null);
//             setIsConnected(false);
//             console.log('Socket disconnected and cleaned up');
//         }
//     }, [socket]);

//     // Reconnect function
//     const reconnectSocket = useCallback(() => {
//         disconnectSocket();
//         connectSocket();
//     }, [disconnectSocket, connectSocket]);

//     // Set up socket when user logs in
//     useEffect(() => {
//         if (currentUser?.id && !socket) {
//             console.log('Initializing socket connection...');
//             connectSocket();
//         }

//         // Cleanup when user logs out or component unmounts
//         return () => {
//             if (!currentUser?.id && socket) {
//                 console.log('Cleaning up socket due to logout');
//                 disconnectSocket();
//             }
//         };
//     }, [currentUser?.id, socket, connectSocket, disconnectSocket]);

//     useEffect(() => {
//         const token = localStorage.getItem('token');
//         if (token && socket?.connected === false) {
//             socket.auth = { token };
//             socket.connect();
//         }
//     }, [socket]);

//     // Context value
//     const contextValue = {
//         socket,
//         isConnected,
//         connectionError,
//         reconnectSocket
//     };

//     return (
//         <SocketContext.Provider value={contextValue}>
//             {children}

//             {/* Connection status indicator */}
//             {connectionError && (
//                 // <div className="fixed bottom-4 right-4 bg-red-500 text-white p-3 rounded-lg shadow-lg flex items-center">
//                 <div>
//                     <span className="mr-3">{connectionError}</span>
//                     <button onClick={reconnectSocket} className="bg-red-700 hover:bg-red-800 px-2 py-1 rounded text-sm">
//                         Reconnect
//                     </button>
//                 </div>
//             )}

//             {!isConnected && !connectionError && (
//                 // <div className="fixed bottom-4 right-4 bg-yellow-500 text-white p-3 rounded-lg shadow-lg flex items-center">
//                 <div>
//                     {/* <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2 animate-pulse" viewBox="0 0 20 20" fill="currentColor">
//                         <path
//                             fillRule="evenodd"
//                             d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
//                             clipRule="evenodd"
//                         />
//                     </svg> */}
//                     <span>Connecting to chat...</span>
//                 </div>
//             )}
//         </SocketContext.Provider>
//     );
// };


import React, { createContext, useContext, useEffect, useState } from "react";
import io from "socket.io-client";
import config from "../config";

const SocketContext = createContext();

export const useSocket = () => {
  return useContext(SocketContext);
};

export const SocketProvider = ({ children }) => {
  const [socket, setSocket] = useState(null);
  const [isConnected, setIsConnected] = useState(false);
  const environment = window.location.hostname === "localhost" ? "development" : "production";
  const apiUrl = config[environment].apiUrl;
  const token = localStorage.getItem("token");

  useEffect(() => {
    if (!token) return;

    const socketInstance = io(apiUrl, {
      auth: { token },
      transports: ["websocket"],
      reconnection: true,
      reconnectionAttempts: 5,
      reconnectionDelay: 1000,
    });

    socketInstance.on("connect", () => {
setIsConnected(true);
      // Join user's own room
      socketInstance.emit("join");
    });

    socketInstance.on("disconnect", () => {
setIsConnected(false);
    });

    socketInstance.on("connect_error", (error) => {
      console.error("Socket connection error:", error);
    });

    setSocket(socketInstance);

    return () => {
      socketInstance.disconnect();
    };
  }, [apiUrl, token]);

  return (
    <SocketContext.Provider value={{ socket, isConnected }}>
      {children}
    </SocketContext.Provider>
  );
};
